module.exports = __webpack_public_path__ + "img/TUR-A-1-II.0ca1989f.png";